type Props = {
  className?: string;
};

export function Unknown(props: Props) {
  const { className } = props;

  return <div className={className}>Unknown content block type</div>;
}
